@if (configs && configs.length) {
  <div class="inline-scroll" (scrollChange)="updatePosition($event)">
    @for (conf of configs; track conf) {
      <configuration-item class="configuration-items" (click)="setSelected(conf)" [ngClass]="{'is-selected': conf.selected}" [conf]="conf" [image]="image"
        [selected]="conf?.configurationModel?.configurationModel?.ModelConfigurationCode === selected?.ModelConfigurationCode" [editMode]="editMode" [variantOrModelIsNew]="variantOrModelIsNew">
      </configuration-item>
    }
  </div>
}